<template>
    <footer class="w-full border-t border-line">
        <div class="page-container py-6 flex justify-between gap-4 eyebrow text-ink-muted">
            <span>Yipp Error Platform</span>
            <span v-if="version" class="font-mono normal-case tracking-normal">{{ version }}</span>
        </div>
    </footer>
</template>

<script lang="ts" setup>
const { version: { tag, commit_hash } } = useRuntimeConfig().public
const version = tag || commit_hash
</script>
